module.exports = __webpack_public_path__ + "static/media/love-bite@2x.67c427fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/love-bite@2x.png
// module id = 1359
// module chunks = 1